import { SAGA_ACTIONS } from 'src/_config'
import { GetCmsContent } from 'src/_common/interfaces/ApiReqRes'
import { useApiCall } from '../common/appApiCallHook'



export function useCmsApi() {

    const callApi = useApiCall()

    const getCmsContent = (data: GetCmsContent, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
        callApi(SAGA_ACTIONS.CMS.GET_CMS, data, onSuccess, onError);
    }

    return {
        callGetCmsContent: getCmsContent,
    }
}